__turbopack_context__.v({
  "coupon-input-button": "clp-icon-secondary-actions-module-scss-module__FHXZ3W__coupon-input-button",
  "icon-actions": "clp-icon-secondary-actions-module-scss-module__FHXZ3W__icon-actions",
  "redeem-coupon-input-mode": "clp-icon-secondary-actions-module-scss-module__FHXZ3W__redeem-coupon-input-mode",
  "secondary-action-container": "clp-icon-secondary-actions-module-scss-module__FHXZ3W__secondary-action-container",
});
